import { PaginationForm } from "@/common/mixins/pagination";
import { Client } from "@/clients/client";

export class BridgeSystemUseCase {
  constructor(private client: Client) {}

  public async getOrders(
    form: PaginationForm,
    status: string,
    fromDate: Date,
    toDate: Date,
    search?: string,
    shopId?: number,
    key?: string,
    orderType?: string
  ) {
    return this.client.bridgeSystem.getOrdersBridgeSystem(
      {
        page: form && form.page,
        limit: form && form.perPage
      },
      status,
      fromDate,
      toDate,
      search,
      shopId,
      key,
      orderType
    );
  }

  public async postApproveOrder(numberOfOrders: number) {
    return this.client.bridgeSystem.postApproveOrderBridgeSystem(
      numberOfOrders
    );
  }

  public async getShop() {
    return this.client.bridgeSystem.getShop();
  }
}
